import axios from 'axios'
const API_URL = "http://supportsoft.in/pizza/api";
const state = {
    auth: false,
    popupOpen: true,
    registerPopup: false,
    otpPopup: false,
    loginPopup: false,
    forgotPopup: false,
    changePasswordPopup: false,
    authid: '',
    errors: '',
    otpErrors: '',
    loginErrors: '',
    forgotErrors: '',
    changeErrors: '',
    isLoggedIn: false,
    authToken: '',
    open_menu: 'orders'
};
const getters = {
    auth: (state) => state.auth,
    popupOpen: (state) => state.popupOpen,
    registerPopup: (state) => state.registerPopup,
    otpPopup: (state) => state.otpPopup,
    loginPopup: (state) => state.loginPopup,
    forgotPopup: (state) => state.forgotPopup,
    changePasswordPopup: (state) => state.changePasswordPopup,
    authid:(state) => state.authid,
    errors: (state) => state.errors,
    otpErrors: (state) => state.otpErrors,
    loginErrors: (state) => state.loginErrors,
    forgotErrors: (state) => state.forgotErrors,
    changeErrors: (state) => state.changeErrors,
    isLoggedIn: (state) => state.isLoggedIn,
    authToken: (state) => state.authToken,
    open_menu: (state) => state.open_menu
};
const actions = {
    async registerUser({commit}, payload){
        let user_key = sessionStorage.getItem('user_key')
        let url = API_URL+'/register';
        let data = { "user_key": user_key ,"name": payload.name, "email": payload.email, "password": payload.password, "terms": payload.terms}
        await axios.post(url, data).then( response => {
            let status = response.data.status
            if(status === 1){
                commit('setAuthId', response.data.auth_id)
            }else{
                commit('setError', response.data.message)
            }
        }).catch(err => {
            console.log("Error " + err)
        })
    },
    async verifyOTP({commit}, payload){
        let user_key = sessionStorage.getItem('user_key')
        let url = API_URL+'/verify_otp';
        let data = { "user_key": user_key ,"id": payload.authid, "otp": payload.otp}
        await axios.post(url, data).then( response => {
            let status = response.data.status
            if(status === 1){
                commit("setLoginErrors" , response.data.message)
                commit('setPopup','login')
            }else{
                commit('setOtpErrors', response.data.message)
            }
        }).catch(err => {
            console.log("Error " + err)
        })
    },
    async forgotPassword({commit}, payload){
        let user_key = sessionStorage.getItem('user_key')
        let url = API_URL+'/forgot_password';
        let data = {"user_key": user_key ,"email": payload}
        await axios.post(url, data).then( response => {
            let status = response.data.status
            if(status === 1){
                commit('setAuthId', response.data.id)
                commit("setChangeErrors" , response.data.message)
                commit('setPopup','change')
            }else{
                commit('setForgotErrors', response.data.message)
            }
        }).catch(err => {
            console.log("Error " + err)
        })
        
    },
    async changePassword({commit}, payload){
        let url = API_URL+'/change_password';
        await axios.post(url, payload).then(response => {
            let status = response.data.status
            if(status === 1){
                commit("setLoginErrors" , response.data.message)
                commit('setPopup','login')
            }else{
                commit('setChangeErrors', response.data.message)
            }
        }).catch(err => {
            console.log("Server Error " + err)
        })
    },
    updatePassword({commit}, payload){
        return new Promise((resolve, reject) => {
            let url = API_URL+'/update_password';
            let access_token = sessionStorage.getItem('access_token');
            axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
                let data = response.data
                resolve(data);
            }).catch(err => {
                console.log("Server Error " + err)
                reject(err)
            })
        })
        
    },
    async accountLogin({commit}, payload){
        let url = API_URL + '/login'
        await axios.post(url, payload).then(response => {
            let status = response.data.status
            if(status === 1){
                let authToken = response.data.access_token
                commit("setAuthToken" , authToken)
            }else if(status === 2){
                commit('setOtpErrors', response.data.message)
                commit('setOtp',response.data.auth_id);

            }else{
                commit('setLoginErrors', response.data.message)
            }
        }).catch(err => {
            console.log("server error " +err)
        })
    },
    async checkLoggedInUser({commit}){
        let url = API_URL + '/check-login'
        let user_key = sessionStorage.getItem('user_key')
        let access_token = sessionStorage.getItem('access_token')
        let payload = { user_key: user_key, access_token: access_token};
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('access_token');
        await axios.post(url, payload).then(response => {
            let status = response.data.status
            if(status === 1){
                let authToken = response.data.access_token
                commit("setAuthToken" , authToken)
            }else{
                commit('setLoginErrors', response.data.message)
            }
        }).catch(err => {
            console.log("Server Error " +err)
        })
    },
    accountLogout({commit}){
       return new Promise((resolve, reject) => {
           let url = API_URL + '/logout'
           let user_key = sessionStorage.getItem('user_key')
           let access_token = sessionStorage.getItem('access_token')
           let payload = { user_key: user_key, access_token: access_token};
           axios.post(url, payload).then(response => {
               let status = response.data.status
               if(status === 1){
                   commit("loggedOutUser", response.data.message)
                   resolve(response.data.message)
               }

           }).then(err => {
               console.log("Server Error " +err)
               reject(err)
           }) 
       }); 
        
    },
    openMenu({commit}, payload){
        commit('setMenu', payload)
    },
    openPopup({commit}, payload){
        commit('setPopup', payload)
    },
    setOtpErrors({commit}, payload){
        commit('setOtpErrors', payload)
    },
    setForgotErrors({commit}, payload){
        commit('setForgotErrors', payload)
    },
    setChangeErrors({commit}, payload){
        commit('setChangeErrors', payload)
    },
    setLoginErrors({commit}, payload){
        commit('setLoginErrors', payload)
    }
};
const mutations = {
    setOtp(state, payload){
        state.registerPopup = false
        state.loginPopup = false
        state.otpPopup = true
        state.authid = payload
    },
    setAuthId(state, payload){
        state.authid = payload,
        state.registerPopup = false
        state.loginPopup = true
    },
    setError(state, payload){
        state.errors = payload
    },
    setOtpErrors(state, payload){
        state.otpErrors = payload
    },
    setLoginErrors(state, payload){
        state.loginErrors = payload
    },
    setForgotErrors(state, payload){
        state.forgotErrors = payload
    },
    setChangeErrors(state, payload){
        state.changeErrors = payload
    },
    setAuthToken(state, payload){
        state.isLoggedIn = true
        state.authToken = payload
        state.loginPopup = false
        state.popupOpen = false
        $(".modal-backdrop").remove()
        sessionStorage.setItem('access_token', payload)
    },
    loggedOutUser(state, payload){
        state.isLoggedIn = false
        state.authToken = ''
        state.loginPopup = false
        state.popupOpen = false
        sessionStorage.removeItem('access_token')
        sessionStorage.removeItem('user_key')
        sessionStorage.removeItem('vue-session-key')
    },
    setMenu(state, payload){
        state.open_menu = payload
    },
    setPopup(state, payload){
        if(payload === 'register'){
            state.registerPopup = true
            state.loginPopup = false
            state.forgotPopup = false
            state.changePasswordPopup = false
        }else if(payload === 'forgot'){
            state.forgotPopup = true
            state.registerPopup = false
            state.loginPopup = false
            state.otpPopup = false
            state.changePasswordPopup = false
        }else if(payload === 'otp'){
            state.otpPopup = true
            state.registerPopup = false
            state.loginPopup = false
            state.forgotPopup = false
            state.changePasswordPopup = false
        }else if(payload === 'login'){
            state.loginPopup = true
            state.registerPopup = false
            state.otpPopup = false
            state.forgotPopup = false
            state.changePasswordPopup = false
            this.loginErrors = ''
        }else if(payload === 'change'){
            state.changePasswordPopup = true
            state.loginPopup = false
            state.registerPopup = false
            state.otpPopup = false
            state.forgotPopup = false

        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}